import { jsonp } from '@ifeng-fe/ui_base';
import { createUid } from '../utils/index';
import md5 from 'md5';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
const apiBaseUrl = jsonpUrl;
/* eslint-enable no-undef */

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    /* eslint-disable */
    while (typeof window === 'object' && window[jsonpCallbackName]) {
        /* eslint-enable */
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

const getAiSummaryList = async (date = '') => {
    const result = await jsonp(`${apiBaseUrl}/getaisummarylist`, {
        data: {
            date,
            proid: 'ifengnewsh5',
            uid: `ifengnewsh5_${createUid()}`,
            gv: '7.71.0',
            publishid: '6001'
        },
        jsonpCallback: createJsonpCallbackName('getaisummarylist'),
        cache: false,
    });

    if (result?.data && result?.code === 0) {
        return result.data;
    } else {
        return {};
    }
};

const getQrcodeImage = async (url) => {
    const res = await jsonp('https://qrcode.ifeng.com/qrcode.php', {
        data: {
            url,
        },
        jsonCallback: createJsonpCallbackName('getQrcode'),
        cache: false,
    });

    return res?.qrcode_url || '';
};

export { getAiSummaryList, getQrcodeImage };
